import React from "react"
import { BruciatoreSelector } from "./bruciatoreSelector"
import BruciatoreData from "./bruciatoreData"
import { MarcaBruciatoreSelector } from "../../marcheBruciatori/components/marcaBruciatoreSelector"
import BruciatoriStore from "../bruciatoriStore"
import { BruciatoreDto } from "../../generated"

interface Props {
    value: number | null,
    onChange: (bruciatore: BruciatoreDto | null) => void
    error?: string;
}

export const SmartBruciatoreSelector = (props: Props) => {
    const bruciatore = BruciatoriStore.use(props.value);
    const [marca, setMarca] = React.useState(bruciatore?.marcaBruciatore ?? null)
    const onChangeMarca = (marca: string | null) => {
        setMarca(marca);
        props.onChange(null);
    }
    const marcaBruciatore = bruciatore?.marcaBruciatore ?? marca ?? "";

    return <div className="row">
        <div className="col-12 col-md-6">
            <MarcaBruciatoreSelector
                value={marcaBruciatore}
                onChange={onChangeMarca}
                label="Marca Bruciatore"
            />
        </div>
        <div className="col-12 col-md-6">
            <BruciatoreSelector
                marca={marcaBruciatore}
                onChange={props.onChange}
                value={props.value}
                label="Bruciatore"
                error={props.error}
            />
            <BruciatoreData
                id={bruciatore?.idBruciatore}
                template={bruciatore =>
                    <div className="d-flex flex-wrap" style={{ marginTop: -10, marginBottom: 5 }}>
                        <div className="me-3">Campo di funzionamento <span className="text-theme">{bruciatore.campoFunzionamentoDa.toFixed(2)}KW - {bruciatore.campoFunzionamentoA.toFixed(2)}KW</span> </div>
                        <div className="me-3">Tipo: <span className="text-theme">{bruciatore.tipoBruciatore}</span></div>
                    </div>
                }
            />
        </div>
    </div>
}